import React from 'react';
import { compose, setPropTypes, pure } from 'recompose';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  },
  leftIcon: {
    padding: '0px 5px'
  },
  overWrap: {
    whiteSpace: 'pre-line',
    width: '500px'
  },
  verticalAlignTop: {
    verticalAlign: 'top'
  },
  buttonDelete: {
    paddingTop: '0px'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  pure,
  setPropTypes(propTypes)
);

const GochiTableBody = enhance(
  ({ classes, shopGroup, orderBy, order, isFullInfo, isFukuoka }) => {
    const sortedResult = _.orderBy(shopGroup, orderBy, order);
    return (
      <>
        <TableBody>
          {sortedResult
            // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((shop, index) => {
              const key = `${shop.shopId}${index}`;
              return (
                <TableRow key={key} className={classes.verticalAlignTop}>
                  <TableCell>{shop.shopName}</TableCell>
                  {!isFukuoka && (
                    <TableCell>
                      {shop.amountWhenBuy
                        ? shop.amountWhenBuy.toLocaleString()
                        : 0}
                    </TableCell>
                  )}
                  <TableCell>
                    {shop.amountWhenUsed
                      ? shop.amountWhenUsed.toLocaleString()
                      : 0}
                  </TableCell>
                  {isFullInfo && (
                    <>
                      {!isFukuoka && (
                        <>
                          <TableCell>
                            {shop.amountDonation
                              ? shop.amountDonation.toLocaleString()
                              : 0}
                          </TableCell>
                          <TableCell>
                            {shop.amountGochiExpirated
                              ? shop.amountGochiExpirated.toLocaleString()
                              : 0}
                          </TableCell>
                        </>
                      )}
                      <TableCell>
                        {shop.totalUserUsedGochi
                          ? shop.totalUserUsedGochi.toLocaleString()
                          : 0}
                      </TableCell>
                    </>
                  )}
                </TableRow>
              );
            })}
        </TableBody>
      </>
    );
  }
);

export default withStyles(styles)(GochiTableBody);
